var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetOneClientRfp } from '@/actions/ClientRfpActionsTs';
import { rfpOneUseCase } from '@/container/Client/Rfp/One/UseCase/RfpOneUseCase';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { wrapDispatch } from '@/utils/actions/dispatch';
export const useRfpClient = () => {
    const { id = '' } = useParams();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    /** 案件情報 */
    const rfp = useTypeSelector((state) => state.clientRfp.one[id]);
    /** 提案一覧 */
    const offers = rfpOneUseCase.useOffers(rfp);
    /**
     * 案件詳細データ 取得
     */
    const rowFetchRfpOne = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiGetOneClientRfp({ path: { id } }, { id }));
    }), [id, dispatch]);
    const { callbackPromiseEvent: fetchRfpOne, doing: loading } = usePromiseDoingCallback({
        initialDoingState: true,
        promiseEvent: rowFetchRfpOne,
        unmountRef,
    });
    // 読み込みを実行
    useEffect(() => {
        fetchRfpOne();
    }, [fetchRfpOne]);
    return {
        fetchRfpOne,
        loading,
        offers,
        rfp,
    };
};
